import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'servicos/auxilio-brasil',
		component: Base,
		children: [
			{
				path: '',
				name: 'AuxilioBrasilList',
				component: List,
				meta: {
					path: '/servicos/auxilio-brasil',
					pai: 'Serviços',
					title: 'Admin - Auxílio Brasil',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Auxílio Brasil',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'AuxilioBrasilNovo',
				component: Form,
				meta: {
					path: '/servicos/auxilio-brasil',
					pai: 'Serviços',
					title: 'Admin - Auxílio Brasil - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Auxílio Brasil',
						class: '',
						active: false,
						url: '/servicos/auxilio-brasil'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'AuxilioBrasilEditar',
				component: Form,
				meta: {
					path: '/servicos/auxilio-brasil',
					pai: 'Serviços',
					title: 'Admin - Auxílio Brasil - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Auxílio Brasil',
						class: '',
						active: false,
						url: '/servicos/auxilio-brasil'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]